import axios from "axios";
import { getDocumentUrl } from "./getDocumentUrl";

export default async function fetchFloorJournals(
  legislatureOrdinal,
  committeeType,
  committeeTypeCode,
  committeeCode,
  chamber,
  meetingDateTime
) {
  try {
    const formattedDateTime = meetingDateTime.includes("T")
      ? meetingDateTime
      : `${meetingDateTime}T00:00:00`;

    const response = await axios.get(
      `${process.env.REACT_APP_LAWS_BACKEND_HOST}/docs/v1/documents/getCommitteeJournals`,
      {
        params: {
          legislatureOrdinal,
          committeeType,
          committeeTypeCode,
          committeeCode,
          chamber,
          meetingDateTime: formattedDateTime,
        },
      }
    );

    const journals = response.data || [];
    if (!journals.length) {
      console.log("No journals returned");
      return null;
    }

    // Sort by SubmittedDate attribute & return the latest journal
    const sorted = journals.sort((a, b) => {
      const getDate = (obj) =>
        obj.attributes.find((attr) => attr.name === "SubmittedDate")
          ?.stringValue || "";
      return new Date(getDate(b)) - new Date(getDate(a));
    });

    const latest = sorted[0];

    // Extract the numeric ID
    const docId = latest.id;

    // Call longPdfUrl endpoint to get real URL
    const longUrl = await getDocumentUrl(docId);

    return longUrl;
  } catch (error) {
    if (error.response?.status !== 404) {
      console.error("Error fetching committee journal:", error);
    }
    return null;
  }
}
